import React from 'react';
import { Nav, ButtonBar } from 'C4';

function pathTrim(path) {
  const index = path.length - 1;
  if (path.charAt(index) === '/') {
    path = path.slice(0, index);
  }
  return path;
}
const Header = ({ pathname }) => (
  <div className="header">
    <Nav pathname={pathname} secondary={pathTrim(pathname) === '/main' && pathname.length < 16} />
    {pathTrim(pathname) === '/main' && pathname.length < 16 && (
      <ButtonBar className="buttonBar" />
    )}
  </div>
);

export default Header;
